import { createWorldApi } from '../../shared/coloring/world/api';

import type { TreeWork, TreeWorld } from './types';

export const OWNER_TOKEN_KEY = 'gameinvitation:new-year-tree-token';

/** Один экземпляр на модуль: хуки используют ссылку как зависимость. */
export const treeApi = createWorldApi<TreeWorld, TreeWork>({
  slug: 'new-year-tree',
  itemsPath: 'works',
  idParam: 'workId',
  ownerTokenKey: OWNER_TOKEN_KEY,
  fallbackMessage: '«Новогодняя ёлка» временно недоступна.',
});
